import React, { PureComponent } from 'react';

export const DiscussionContext = React.createContext();

export class DiscussionProvider extends PureComponent {
    render() {
        return (
            <DiscussionContext.Provider
                value={{
                    currentUserId: this.props.currentUserId,
                    filePreviewPath: this.props.filePreviewPath,
                    canCreateTask: this.props.canCreateTask,
                    dateFormat: this.props.dateFormat,
                    projectId: this.props.projectId,
                    urlPreviewEnabled: this.props.urlPreviewEnabled,
                    gifSize: this.props.gifSize,
                    users: this.props.users,
                    systemAsAction: this.props.systemAsAction,
                    botUseUserName: this.props.botUseUserName,
                    controlDeleteText: this.props.controlDeleteText,
                    pinnedMessage: this.props.pinnedMessage,
                    pinnedMessageBy: this.props.pinnedMessageBy,
                    onThreadActivate: this.props.onThreadActivate,
                    onPinMessage: this.props.onPinMessage,
                    onEditStart: this.props.onEditStart,
                    isLastSelfMessage: this.props.isLastSelfMessage,
                    lastSelfMessageCtrl: this.props.lastSelfMessageCtrl
                }}
            >
                { this.props.children }
            </DiscussionContext.Provider>
        );
    }
}
